import styled from 'styled-components'
import { ChevronRight } from 'styled-icons/octicons/ChevronRight'
import variables from '../../styles/variables'
import { headerStyles } from '../../styles/global'
import { Heading } from '..'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding-bottom: 40px;

  @media ${variables.media.md} {
    padding-right: 20px;
  }
`

export const Card = styled.div`
  position: relative;
  background-color: #f9f9f9;
  border-left: 5px solid ${props => props.color};
  border-radius: 3px;
  padding: 25px;
  transition: all 0.5s ease;

  @media ${variables.media.md} {
    height: 100%;
  }
`

export const CardHeader = styled(Heading)`
  ${headerStyles.headerXXSmall};
  margin: 15px 0;
  color: ${variables.colors.oracle.dark};
`

export const LinkRow = styled.div`
  margin: 20px 0;

  @media ${variables.media.md} {
    margin: 0;
  }
`

export const Chevron = styled(ChevronRight)`
  width: 12px;
  height: 12px;
`

export const Introduction = styled.p`
  color: grey;
`

export const UseCaseImgContainer = styled.div`
  display: flex;
  justify-content: center;
`

export const UseCaseImg = styled.img`
  width: 100%;
  max-width: 400px;
  margin-top: 20px;
  @media ${variables.media.md} {
    margin: 0;
  }
`
